import { type ShowPriceConfig } from '@bbkPricingPage/events/defn';
import { getFormattedAmount } from '@bbkPricingPage/lib/currencies';

type ShowTotalPriceProps = {
  priceConfig?: ShowPriceConfig;
  priceValue: number;
  currency: string;
};

export const ShowTotalPrice = ({
  priceConfig,
  priceValue,
  currency,
}: ShowTotalPriceProps) => {
  if (!priceConfig) {
    return null;
  }

  const formattedPrice = getFormattedAmount(priceValue, currency);
  const prefix = priceConfig.prefix || 'Total Price';
  const parts = [prefix, formattedPrice, priceConfig.suffix].filter(Boolean);
  const displayText = parts.join(' ');

  return (
    <div className="tw-mt-1 tw-text-center tw-text-sm tw-text-[var(--pricing-page-text-font-text-color)]">
      {displayText}
    </div>
  );
};
